module.exports = __webpack_public_path__ + "static/media/arken.0c4c9840.png";